module.exports = __webpack_public_path__ + "media/images/pc/items/board/aluminumpanel-a97c8d1183de7a40521fc05c2ec52068.jpg";